import { Button } from "@/components/ui/button";

interface DraftBannerProps {
  onRestore: () => void;
  onDiscard: () => void;
}

export function DraftBanner({ onRestore, onDiscard }: DraftBannerProps) {
  return (
    <div
      // role="status" (polite live region) — this banner is a passive
      // restore-or-discard prompt, not an emergency the screen reader
      // should interrupt the user for. Using role="alert" caused AT to
      // cut into whatever the user was doing on every page load with
      // a stale draft.
      role="status"
      className="z-50 border-b border-primary/40 bg-card/95 backdrop-blur"
    >
      <div className="mx-auto flex w-full max-w-[1100px] flex-wrap items-center justify-between gap-3 px-4 py-2">
        <p className="text-sm font-semibold text-primary">
          You have an unsaved draft. Would you like to restore it?
        </p>
        <div className="flex gap-2">
          <Button variant="secondary" size="sm" onClick={onRestore}>
            Restore Draft
          </Button>
          <Button variant="secondary" size="sm" onClick={onDiscard}>
            Discard
          </Button>
        </div>
      </div>
    </div>
  );
}
